module.exports = __webpack_public_path__ + "static/media/brand.381bad31.svg";